import React from 'react';
import PropTypes from 'prop-types';

// Components
import RatingStar from '@/braun/components/atoms/RatingStar';

const CompareProductReviews = ({ numberOfReviews, averageRating }) => {
  // In case a null value is passed, default prop is ignored
  const totalReviews = numberOfReviews || 0;
  const totalRating = averageRating || 0;

  const reviewStars = [1, 2, 3, 4, 5].map(rating =>
    rating >= totalRating ? (
      <RatingStar key={`rating-star-${rating}`} isEmpty />
    ) : (
      <RatingStar key={`rating-star-${rating}`} isEmpty={false} />
    ),
  );

  return (
    <div className='bra-prodTile__rating'>
      <div className='bra-prodTile__stars'>{reviewStars}</div>
      <p className='bra-prodTile__reviewCounter'>
        (<span>{totalReviews}</span>)
      </p>
    </div>
  );
};

CompareProductReviews.propTypes = {
  numberOfReviews: PropTypes.number,
  averageRating: PropTypes.number,
};

CompareProductReviews.defaultProps = {
  numberOfReviews: 0,
  averageRating: 0,
};

export default CompareProductReviews;
